<template>
  <div class="page-caseinfo" style="background: #0d0d0d">
    <div class="caseinfo-content">
      <div class="crumbs-box">
        首页 > 全部案例 > <span>{{ infoData.title }}</span>
      </div>
      <img :src="getImgUrl(infoData.thumb)" alt="" class="icon" />
      <!-- <div class="img"></div> -->
      <div class="title">{{ infoData.title }}</div>
      <div class="text">{{ infoData.describe || "" }}</div>
      <!-- <div class="img"></div>
      <div class="img2"></div> -->
      <div v-html="infoData.content"></div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Footer from "@/components/Footer";
import { pageApi } from "@/api";
export default {
  components: { Footer },
  data() {
    return {
      infoData: {},
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      pageApi.getCaseDetail({ id: this.$route.query.id }).then((res) => {
        this.infoData = res.result;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import url("./index.scss");
</style>
